
<div class="modal-dialog" style="max-width: 600px;">
  <div class="modal-content">
    <form [formGroup]="expenseForm" (ngSubmit)="submit()">
      <div class="modal-header">
        <h4 class="modal-title">Create Expense</h4>
        <button class="close" type="button" (click)="close()">&times;</button>
      </div>
      <div class="modal-body">
        <error [error]="error"></error>
        <div class="row">
          <div class="form-group col-6">
            <div class="inline-block">
              <label class="required" for="expenseDate">Expense Date:</label>
            </div>
            <div class="input-group">
              <input class="form-control" id="expenseDate" formControlName="expenseDate" name="expenseDate" type="text">
              <datepicker class="right input-group-append" (outputEvents)="expenseDateChange($event)"></datepicker>
            </div>
          </div>
          <div class="form-group col-6">
            <label for="createExpensePeriod">Period</label>
            <input class="form-control" id="createExpensePeriod" type="text" formControlName="period" name="period">
          </div>
          <div class="form-group col-6">
            <label class="required" for="createExpenseUSDAmount">Amount (USD)</label>
            <input class="form-control" id="createExpenseUSDAmount" type="number" formControlName="usdAmount" name="usdAmount">
          </div>
          <div class="form-group col-6">
            <label class="required" for="createExpenseLocalAmount">Amount (LOCAL)</label>
            <input class="form-control" id="createExpenseLocalAmount" type="number" formControlName="localAmount" name="localAmount">
          </div>
          <div class="form-group col-12">
            <label class="required" for="createExpenseBucket">Bucket</label>
            <select class="form-control" id="createExpenseBucket" formControlName="bucket" name="bucket">
              <option value=""></option>
              <option value="Project setup">Project setup</option>
              <option value="Site set up">Site set up</option>
              <option value="Site Deployment Execution">Site Deployment Execution</option>
              <option value="Project Monitoring and Control">Project Monitoring and Control</option>
              <option value="Travel">Travel</option>
              <option value="Project Closure">Project Closure</option>
              <option value="Other">Other</option>
            </select>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-outline-secondary" type="button" (click)="close()">Close</button>
        <button class="btn btn-primary" type="submit" [disabled]="!expenseForm.valid">Save</button>
      </div>
    </form>
  </div>
</div>